<template class="">
  <!-- page meta -->
  <div>
    <Head>
      <title>Platform | Best Pricing</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <!-- <meta name="description" content="Your page description" /> -->
    </Head>
  </div>
  <!-- content start -->
  <div
    class="relative min-[1140px]:max-w-[1200px] h-full container mx-auto bg-transparent"
  >
    <!-- hero section -->
    <section
      id="section1"
      class="section1 hero-section mx-auto relative mt-[150px] justify-center gap-1 bg-transparent lg:py-0"
      :style="backgroundImageStyle"
    >
      <div class="mt-0 bg-transparent px-[25px] text-center xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#fff] sm:text-[40px] lg:text-[50px] lg:leading-[69px] xl:text-[50px]"
        >
          The best member solution, for the best price.
        </h1>
      </div>
      <!-- yearly/monthly tab toggler -->
      <div
        class="mt-[30px] w-[230px] h-[47px] rounded-full border border-white flex mx-auto"
      >
        <div
          class="rounded-full bg-white text-center w-[115px] py-auto shadow-lg pt-2"
        >
          <a class="self-center text-[#2d8bff] font-semibold text-lg my-auto"
            >Yearly</a
          >
        </div>
        <div
          class="rounded-3xl bg-transparent text-center align-middle w-[115px] pt-2"
        >
          <a class="items-center font-semibold text-lg my-auto text-white"
            >Monthly</a
          >
        </div>
      </div>
      <!-- pricing cards -->
      <div class="flex mt-[30px] gap-[4px]">
        <!-- starter card -->
        <div
          class="rounded-lg bg-white shadow-lg border-b-4 border-[#00b884] text-center px-auto pt-[55px] pb-[25px] w-[240px]"
        >
          <h3 class="text-lg text-[#00b884] font-semibold">STARTER</h3>
          <h4 class="text-sm text-[#292D34]">Best for personal use</h4>
          <div class="flex mx-auto justify-center">
            <h4 class="text-[25px] font-medium text-[#00b884] mt-[30px]">$</h4>
            <h4 class="text-[55px] font-semibold text-[#00b884]">87</h4>
          </div>
          <h4 class="text-sm font-semibold text-[#b9bec7]">PER MONTH</h4>
          <button
            @click="toggleGrabber"
            type="button"
            class="h-[56px] w-[200px] mt-[25px] mb-[20px] rounded-[9px] bg-[#00b884] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
          >
            Get Started
          </button>
          <ul class="text-center">
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
            <li
              class="text-[#292D34] text-xs font-normal my-3"
              data-tooltip="This is awesome"
            >
              100MB Storage
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
export default {
  layout: DefaultLayout,

  computed: {
    backgroundImageStyle() {
      const imagePath = this.$filters.public_path(
        'new/download-platforma-hero-bg.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 589px;
  width: 1700px;
  display: block;
  transform: translateY(-28%) translateX(-15%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
  z-index: 0;
}
</style>
